import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AdjustmentModalTemplateComponent } from '../../../adjustments/adjustment-modal-template/adjustment-modal-template.component';

export const EDIT_TEXT = 'Save';
export const ADD_TEXT = 'Add';

@Component({
  selector: 'app-reason-from',
  templateUrl: './reason-form.component.html',
  styleUrls: ['./reason-form.component.css'],
})
export class ReasonFormComponent implements OnInit {
  @ViewChild(AdjustmentModalTemplateComponent, { static: false }) modal: AdjustmentModalTemplateComponent;
  @Input() reasonType: string;
  @Input() reasonText: string;
  @Input() readOnly: string;

  reasonForm: UntypedFormGroup;
  saveButtonText: string = ADD_TEXT;
  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    if (this.reasonText != null && this.reasonText.length > 0) {
      this.saveButtonText = EDIT_TEXT;
    }

    this.reasonForm = this.fb.group(
      {
        reason: [this.reasonText, Validators.required],
      },
      { updateOn: 'change' }
    );
  }

  onSubmit() {
    if (this.reasonForm.valid) {
      this.reasonText = this.reasonForm.value.reason;
      this.close(this.reasonText);
    }
  }

  close(reason?: string) {
    if (reason != null && reason.length > 0) {
      this.modal.close({ reasonText: reason, reasonType: this.reasonType });
    } else {
      this.modal.close(null);
    }
  }
}
